

document.addEventListener('DOMContentLoaded', function() {
  const header = document.getElementById('mainHeader');
  const heroSection = document.getElementById('heroSection');
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenuToggle2 = document.getElementById('mobileMenuToggle2');
  const drawerOverlay = document.getElementById('drawerOverlay');
  const desktopMenuToggle = document.getElementById('desktopMenuToggle');
  const desktopMenuToggleActive = document.getElementById('desktopMenuToggleActive');
  const universalDrawer = document.getElementById('universalDrawer');
  const closeDrawerBtn = document.getElementById('closeDrawerBtn');
  const navItems = document.querySelectorAll('.nav-item');

  let isHoveringHero = false;
  let hoverTimeout = null;
  let currentActiveNavItem = null;
  let lastScrollPosition = 0;
  let isScrolling = false;
  let scrollTimer = null;
  let lastScrollTop = 0;
  let scrollDelta = 0;

  /* Read the flag Liquid rendered, so JS and the server-rendered class can
     never disagree - they did on localised homepages like /en-gb, where the
     path check said "not home" and the template said "home". */
  const isHomepage = header && header.dataset.home
    ? header.dataset.home === 'true'
    : (window.location.pathname === '/' || window.location.pathname === '');
  
  // Search drawer triggers - redirect to search page instead
  const desktopSearchButton = document.getElementById('searchButton');
  const desktopSearchButtonActive = document.getElementById('searchButtonActive');
  const mobileSearchInput = document.getElementById('mobileSearchInput');
  const mobileSearchButton = document.getElementById('mobileSearchButton');
  const searchIcons = document.querySelectorAll('.js-search-header');

  function activateHeader() {
    if (header) {
      header.classList.add('active');
      if (window.innerWidth > 1024) {
        requestAnimationFrame(syncHeaderBottomVar);
      }
    }
  }

  function deactivateHeader() {
    if (isHomepage && header && window.scrollY < 60 && !isHoveringHero) {
      header.classList.remove('active');
    }
  }

  // Hide header (add hide class)
  function hideHeader() {
    if (header && !header.classList.contains('hidden')) {
      header.classList.add('hidden');
    }
  }

  // Show header (remove hide class)
  function showHeader() {
    if (header && header.classList.contains('hidden')) {
      header.classList.remove('hidden');
    }
  }

  // Close all mega menus
  function closeAllMegaMenus() {
    navItems.forEach(item => {
      item.classList.remove('active');
    });
    currentActiveNavItem = null;
    closeMegaOpenState();

    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }
  }

  let megaOpenTimer = null;

  function syncHeaderBottomVar() {
    if (!header) return;
    header.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
  }

  /* The header is position: fixed, so every page's content starts underneath it
     and has to reserve its height. Published once here, on every breakpoint, so
     pages can just say `padding-top: var(--ol-fixed-header-h)` instead of each
     one measuring the header again or hard-coding a number that goes stale. */
  function publishHeaderHeight() {
    if (!header) return;
    /* offsetHeight, not the bounding rect: the header is translated out of view
       while scrolling down and a transformed rect reports the wrong height. */
    var height = header.offsetHeight;
    if (height > 0) {
      document.documentElement.style.setProperty('--ol-fixed-header-h', height + 'px');
    }
  }

  publishHeaderHeight();
  window.addEventListener('load', publishHeaderHeight);
  window.addEventListener('resize', publishHeaderHeight);

  function openMegaOpenState() {
    if (!header || window.innerWidth <= 1024) return;
    syncHeaderBottomVar();
    header.classList.add('mega-open');
    requestAnimationFrame(function () {
      syncHeaderBottomVar();
      requestAnimationFrame(syncHeaderBottomVar);
    });
  }

  function closeMegaOpenState() {
    if (!header) return;
    header.classList.remove('mega-open');
  }

  function scheduleMegaOpenClose() {
    if (megaOpenTimer) clearTimeout(megaOpenTimer);
    megaOpenTimer = setTimeout(function () {
      var hoveredItem = null;

      navItems.forEach(function (item) {
        var mega = item.querySelector('.mega-menu');
        if (item.matches(':hover') || (mega && mega.matches(':hover'))) {
          hoveredItem = item;
        }
      });

      if (hoveredItem) {
        if (currentActiveNavItem && currentActiveNavItem !== hoveredItem) {
          currentActiveNavItem.classList.remove('active');
        }
        hoveredItem.classList.add('active');
        currentActiveNavItem = hoveredItem;
        openMegaOpenState();
      } else {
        closeAllMegaMenus();
      }

      megaOpenTimer = null;
    }, 160);
  }

  // Search functionality - open the drawer
  function openSearchDrawerFromButton() {
    if (typeof window.openSearchDrawer === 'function') {
      window.openSearchDrawer();
    }
  }

  // Handle search triggers - open the drawer
  if (desktopSearchButton) {
    desktopSearchButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSearchDrawerFromButton();
    });
  }
  
  if (desktopSearchButtonActive) {
    desktopSearchButtonActive.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSearchDrawerFromButton();
    });
  }

  // Handle mobile search input - redirect to search page on enter
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = this.value.trim();
        if (query) {
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        }
      }
    });
  }

  if (mobileSearchButton) {
    mobileSearchButton.addEventListener('click', function(e) {
      e.preventDefault();
      const query = mobileSearchInput ? mobileSearchInput.value.trim() : '';
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      } else {
        openSearchDrawerFromButton();
      }
    });
  }

  if (searchIcons.length > 0) {
    searchIcons.forEach(icon => {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openSearchDrawerFromButton();
      });
    });
  }

  // ============================================
  // MEGA MENU FUNCTIONS
  // ============================================
  function handleNavItemOpen(item) {
    if (window.innerWidth <= 1024 || !header) return;

    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }

    if (currentActiveNavItem && currentActiveNavItem !== item) {
      currentActiveNavItem.classList.remove('active');
    }

    item.classList.add('active');
    currentActiveNavItem = item;
    openMegaOpenState();
  }

  if (header) {
    header.addEventListener('mouseenter', function () {
      if (window.innerWidth > 1024) syncHeaderBottomVar();
    });
  }

  navItems.forEach(item => {
    const menuLink = item.querySelector('a');
    const megaMenu = item.querySelector('.mega-menu');

    item.addEventListener('mouseenter', function () {
      if (!megaMenu) return;
      handleNavItemOpen(item);
    });

    if (menuLink) {
      menuLink.addEventListener('mouseenter', function () {
        if (megaMenu) handleNavItemOpen(item);
      });
    }

    item.addEventListener('mouseleave', () => {
      if (window.innerWidth > 1024) {
        scheduleMegaOpenClose();
      }
    });

    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', () => {
        if (window.innerWidth > 1024) {
          if (megaOpenTimer) {
            clearTimeout(megaOpenTimer);
            megaOpenTimer = null;
          }
          handleNavItemOpen(item);
        }
      });

      megaMenu.addEventListener('mouseleave', () => {
        if (window.innerWidth > 1024) {
          scheduleMegaOpenClose();
        }
      });
    }
  });

  window.addEventListener('resize', function () {
    if (header && header.classList.contains('mega-open')) {
      syncHeaderBottomVar();
    }
  });

  // ============================================
  // UNIVERSAL DRAWER FUNCTIONS
  // ============================================
  function openUniversalDrawer() {
    universalDrawer.classList.add('open');
    drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    showHeader(); // Ensure header is visible when drawer opens
  }

  function closeUniversalDrawer() {
    universalDrawer.classList.remove('open');
    drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (universalDrawer) {
    universalDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (drawerOverlay) {
    drawerOverlay.classList.remove('open');
  }

  if (desktopMenuToggle) desktopMenuToggle.addEventListener('click', openUniversalDrawer);
  if (desktopMenuToggleActive) desktopMenuToggleActive.addEventListener('click', openUniversalDrawer);
  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openUniversalDrawer);
  if (mobileMenuToggle2) mobileMenuToggle2.addEventListener('click', openUniversalDrawer);
  if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeUniversalDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeUniversalDrawer);

  // ============================================
  // HERO SECTION HOVER EFFECTS
  // ============================================
  if (heroSection) {
    heroSection.addEventListener('mouseenter', () => {
      isHoveringHero = true;
      activateHeader();
      showHeader(); // Show header when hovering hero
    });
    heroSection.addEventListener('mouseleave', () => {
      isHoveringHero = false;
      deactivateHeader();
    });
  }

  // ============================================
  // SCROLL HANDLER
  // ============================================
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    const scrollDifference = currentScroll - lastScrollTop;
    
    isScrolling = true;
    
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    
    // Handle header active state based on scroll position
    if (!isHomepage) {
      // On non-homepage routes, always keep header active
      activateHeader();
    } else {
      if (currentScroll > 60) {
        activateHeader();
      } else {
        if (!isHoveringHero) {
          deactivateHeader();
        }
      }
    }
    
    // Handle hide/show on scroll (only when header is active and not on hero hover)
    if (header && header.classList.contains('active')) {
      // Don't hide header on homepage when hovering hero
      if (!(isHomepage && isHoveringHero && currentScroll < 60)) {
        // Scrolling down and past threshold
        if (scrollDifference > 5 && currentScroll > 60) {
          hideHeader();
        } 
        // Scrolling up
        else if (scrollDifference < -5) {
          showHeader();
        }
      }
    }
    
    // Close mega menus when scrolling
    if (currentScroll !== lastScrollPosition) {
      closeAllMegaMenus();
    }
    
    lastScrollPosition = currentScroll;
    lastScrollTop = currentScroll;
    
    scrollTimer = setTimeout(() => {
      isScrolling = false;
    }, 100);
  });

  // ============================================
  // CLOSE MEGA MENUS ON CLICK OUTSIDE
  // ============================================
  document.addEventListener('click', (e) => {
    let isClickOnNav = false;
    navItems.forEach(item => {
      if (item.contains(e.target)) {
        isClickOnNav = true;
      }
    });
    
    if (!isClickOnNav && window.innerWidth > 1024) {
      closeAllMegaMenus();
    }
  });

  // ============================================
  // CLOSE MEGA MENUS ON WINDOW RESIZE
  // ============================================
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1024) {
      closeAllMegaMenus();
    }
  });

  // ============================================
  // WISHLIST
  // ============================================
  const wishlistToggle = document.getElementById('wishlistToggle');
  const wishlistToggleActive = document.getElementById('wishlistToggleActive');

  if (wishlistToggle) {
    wishlistToggle.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '#swym-wishlist';
    });
  }

  if (wishlistToggleActive) {
    wishlistToggleActive.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '#swym-wishlist';
    });
  }

  // ============================================
  // INITIAL CHECK
  // ============================================
  if (!isHomepage) {
    // On non-homepage routes, always active
    activateHeader();
    showHeader();
  } else {
    // On homepage, check scroll position
    if (window.scrollY > 60) {
      activateHeader();
      showHeader();
    } else {
      deactivateHeader();
    }
  }

  if (header && window.innerWidth > 1024) {
    syncHeaderBottomVar();
    window.addEventListener('load', syncHeaderBottomVar);
  }

});


// document.addEventListener('DOMContentLoaded', function() {
//   const header = document.getElementById('mainHeader');
//   const heroSection = document.getElementById('heroSection');
//   const mobileMenuToggle = document.getElementById('mobileMenuToggle');
//   const mobileMenuToggle2 = document.getElementById('mobileMenuToggle2');
//   const drawerOverlay = document.getElementById('drawerOverlay');
//   const desktopMenuToggle = document.getElementById('desktopMenuToggle');
//   const desktopMenuToggleActive = document.getElementById('desktopMenuToggleActive');
//   const universalDrawer = document.getElementById('universalDrawer');
//   const closeDrawerBtn = document.getElementById('closeDrawerBtn');
//   const navItems = document.querySelectorAll('.nav-item');

//   let isHoveringHero = false;
//   let hoverTimeout = null;
//   let currentActiveNavItem = null;
//   let lastScrollPosition = 0;
//   let isScrolling = false;
//   let scrollTimer = null;

//   function isMobile() {
//     return window.innerWidth <= 1024;
//   }

//   // Search drawer triggers - redirect to search page instead
//   const desktopSearchButton = document.getElementById('searchButton');
//   const desktopSearchButtonActive = document.getElementById('searchButtonActive');
//   const mobileSearchInput = document.getElementById('mobileSearchInput');
//   const mobileSearchButton = document.getElementById('mobileSearchButton');
//   const searchIcons = document.querySelectorAll('.js-search-header');

//   function activateHeader() {
//     if (header) {
//       header.classList.add('active');
//     }
//   }

//   function deactivateHeader() {
//     // NEVER deactivate on mobile - mobile always has active class
//     if (isMobile()) {
//       return;
//     }

//     if (header && window.scrollY < 60 && !isHoveringHero) {
//       header.classList.remove('active');
//     }
//   }

//   // Close all mega menus
//   function closeAllMegaMenus() {
//     navItems.forEach(item => {
//       item.classList.remove('active');
//     });
//     currentActiveNavItem = null;
    
//     if (hoverTimeout) {
//       clearTimeout(hoverTimeout);
//       hoverTimeout = null;
//     }
//   }

//   // Search functionality - open the drawer
//   function openSearchDrawerFromButton() {
//     if (typeof window.openSearchDrawer === 'function') {
//       window.openSearchDrawer();
//     }
//   }

//   // Handle search triggers - open the drawer
//   if (desktopSearchButton) {
//     desktopSearchButton.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       openSearchDrawerFromButton();
//     });
//   }
  
//   if (desktopSearchButtonActive) {
//     desktopSearchButtonActive.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       openSearchDrawerFromButton();
//     });
//   }

//   // Handle mobile search input - redirect to search page on enter
//   if (mobileSearchInput) {
//     mobileSearchInput.addEventListener('keypress', function(e) {
//       if (e.key === 'Enter') {
//         e.preventDefault();
//         const query = this.value.trim();
//         if (query) {
//           window.location.href = `/search?q=${encodeURIComponent(query)}`;
//         }
//       }
//     });
//   }

//   if (mobileSearchButton) {
//     mobileSearchButton.addEventListener('click', function(e) {
//       e.preventDefault();
//       const query = mobileSearchInput ? mobileSearchInput.value.trim() : '';
//       if (query) {
//         window.location.href = `/search?q=${encodeURIComponent(query)}`;
//       } else {
//         openSearchDrawerFromButton();
//       }
//     });
//   }

//   if (searchIcons.length > 0) {
//     searchIcons.forEach(icon => {
//       icon.addEventListener('click', function(e) {
//         e.preventDefault();
//         e.stopPropagation();
//         openSearchDrawerFromButton();
//       });
//     });
//   }

//   // ============================================
//   // MEGA MENU FUNCTIONS
//   // ============================================
//   navItems.forEach(item => {
//     const menuLink = item.querySelector('a');
    
//     if (menuLink) {
//       menuLink.addEventListener('mouseenter', () => {
//         if (window.innerWidth > 1024 && header.classList.contains('active') && !isScrolling) {
//           if (hoverTimeout) {
//             clearTimeout(hoverTimeout);
//             hoverTimeout = null;
//           }
          
//           if (currentActiveNavItem && currentActiveNavItem !== item) {
//             currentActiveNavItem.classList.remove('active');
//           }
          
//           item.classList.add('active');
//           currentActiveNavItem = item;
//         }
//       });
//     }
    
//     item.addEventListener('mouseleave', () => {
//       if (window.innerWidth > 1024 && !isScrolling) {
//         hoverTimeout = setTimeout(() => {
//           let isHoveringOtherItem = false;
//           navItems.forEach(navItem => {
//             if (navItem !== item && navItem.matches(':hover')) {
//               isHoveringOtherItem = true;
//             }
//           });
          
//           if (!isHoveringOtherItem) {
//             item.classList.remove('active');
//             currentActiveNavItem = null;
//           }
//           hoverTimeout = null;
//         }, 50);
//       }
//     });
//   });

//   // ============================================
//   // UNIVERSAL DRAWER FUNCTIONS
//   // ============================================
//   function openUniversalDrawer() {
//     universalDrawer.classList.add('open');
//     drawerOverlay.classList.add('open');
//     document.body.style.overflow = 'hidden';
//   }

//   function closeUniversalDrawer() {
//     universalDrawer.classList.remove('open');
//     drawerOverlay.classList.remove('open');
//     document.body.style.overflow = '';
//   }

//   if (desktopMenuToggle) desktopMenuToggle.addEventListener('click', openUniversalDrawer);
//   if (desktopMenuToggleActive) desktopMenuToggleActive.addEventListener('click', openUniversalDrawer);
//   if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openUniversalDrawer);
//   if (mobileMenuToggle2) mobileMenuToggle2.addEventListener('click', openUniversalDrawer);
//   if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeUniversalDrawer);
//   if (drawerOverlay) drawerOverlay.addEventListener('click', closeUniversalDrawer);

//   // ============================================
//   // HERO SECTION HOVER EFFECTS
//   // ============================================
//   if (heroSection) {
//     heroSection.addEventListener('mouseenter', () => {
//       isHoveringHero = true;
//       activateHeader();
//     });
//     heroSection.addEventListener('mouseleave', () => {
//       isHoveringHero = false;
//       deactivateHeader();
//     });
//   }

//   // ============================================
//   // SCROLL HANDLER - OPTIMIZED
//   // ============================================
//   window.addEventListener('scroll', () => {
//     const currentScroll = window.scrollY;
    
//     isScrolling = true;
    
//     if (scrollTimer) {
//       clearTimeout(scrollTimer);
//     }
    
//     // Only handle scroll-based activation for desktop
//     if (!isMobile()) {
//       if (currentScroll > 60) {
//         activateHeader();
//       } else {
//         if (!isHoveringHero) {
//           deactivateHeader();
//         }
//       }
//     }
    
//     if (currentScroll !== lastScrollPosition) {
//       closeAllMegaMenus();
//     }
    
//     lastScrollPosition = currentScroll;
    
//     scrollTimer = setTimeout(() => {
//       isScrolling = false;
//     }, 100);
//   });

//   // ============================================
//   // CLOSE MEGA MENUS ON CLICK OUTSIDE
//   // ============================================
//   document.addEventListener('click', (e) => {
//     let isClickOnNav = false;
//     navItems.forEach(item => {
//       if (item.contains(e.target)) {
//         isClickOnNav = true;
//       }
//     });
    
//     if (!isClickOnNav && window.innerWidth > 1024) {
//       closeAllMegaMenus();
//     }
//   });

//   // ============================================
//   // CLOSE MEGA MENUS ON WINDOW RESIZE
//   // ============================================
//   window.addEventListener('resize', () => {
//     if (window.innerWidth <= 1024) {
//       closeAllMegaMenus();
//       // Ensure header stays active on mobile after resize
//       activateHeader();
//     } else {
//       // When switching to desktop, check scroll position
//       if (window.scrollY <= 60 && !isHoveringHero) {
//         deactivateHeader();
//       }
//     }
//   });

//   // ============================================
//   // WISHLIST
//   // ============================================
//   const wishlistToggle = document.getElementById('wishlistToggle');
//   const wishlistToggleActive = document.getElementById('wishlistToggleActive');

//   if (wishlistToggle) {
//     wishlistToggle.addEventListener('click', (e) => {
//       e.preventDefault();
//       window.location.href = '#swym-wishlist';
//     });
//   }

//   if (wishlistToggleActive) {
//     wishlistToggleActive.addEventListener('click', (e) => {
//       e.preventDefault();
//       window.location.href = '#swym-wishlist';
//     });
//   }

//   // ============================================
//   // INITIAL CHECK
//   // ============================================
//   if (isMobile()) {
//     // On mobile: ALWAYS add active class
//     activateHeader();
//   } else {
//     if (window.scrollY > 60) {
//       activateHeader();
//     } else {
//       deactivateHeader();
//     }
//   }
// });